// extracted by mini-css-extract-plugin
export default {"wrapper":"PJZxp","description":"UWqFy ZdH1P","gallery":"DFeyK"};